import { useState } from 'react';
import { t } from '@lingui/core/macro';
import { IconButton, Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { MenuFooter } from './MenuFooter';
export function NumberMenu(props) {
    const { property, initialValue, onChange, onClear } = props;
    const { label } = property;
    const [value, setValue] = useState((initialValue === null || initialValue === void 0 ? void 0 : initialValue.toString()) || '');
    const handleResetToInitialValue = () => {
        setValue((initialValue === null || initialValue === void 0 ? void 0 : initialValue.toString()) || '');
    };
    const handleChange = (newValue) => {
        setValue(newValue);
    };
    const handleClearInput = () => {
        setValue('');
    };
    const handleSubmit = () => {
        if (value === '') {
            onClear(property);
            return;
        }
        const numberValue = Number(value);
        if (Number.isNaN(numberValue)) {
            setValue('');
        }
        else {
            onChange(property, numberValue);
        }
    };
    const handleClear = () => {
        onClear(property);
    };
    return (<Menu.ItemNested target={label} onClose={handleResetToInitialValue}>
      <Menu.HeaderInput type="number" value={value} onChange={handleChange} placeholder={t({
            message: 'Enter value...',
            comment: 'Bulk action: Metadata - Number menu - Enter number placeholder',
        })} actions={<IconButton size="xs" appearance="ghost" onClick={handleClearInput}>
            <Falcon icon="xmark"/>
          </IconButton>}/>
      <MenuFooter withoutBorder onSave={handleSubmit} onClear={handleClear}/>
    </Menu.ItemNested>);
}
